(function () {
  var modal = null;
  var backdrop = null;
  var currentHandle = null;
  var selectedVariantId = null;

  function buildModalShell() {
    if (modal) return;

    backdrop = document.createElement('div');
    backdrop.className = 'lia-quick-add-backdrop';

    modal = document.createElement('div');
    modal.className = 'lia-quick-add-modal';
    modal.innerHTML =
      '<button type="button" class="lia-quick-add-close" aria-label="Close">&times;</button>' +
      '<div class="lia-quick-add-body"></div>';

    document.body.appendChild(backdrop);
    document.body.appendChild(modal);

    backdrop.addEventListener('click', closeModal);
    modal.querySelector('.lia-quick-add-close').addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  function openModal() {
    buildModalShell();
    document.body.classList.add('lia-quick-add-open');
    backdrop.classList.add('is-visible');
    modal.classList.add('is-visible');
  }

  function closeModal() {
    if (!modal) return;
    document.body.classList.remove('lia-quick-add-open');
    backdrop.classList.remove('is-visible');
    modal.classList.remove('is-visible');
    selectedVariantId = null;
    currentHandle = null;
  }

  function renderLoading() {
    modal.querySelector('.lia-quick-add-body').innerHTML =
      '<div class="lia-quick-add-loading">Loading…</div>';
  }

  function renderError() {
    modal.querySelector('.lia-quick-add-body').innerHTML =
      '<div class="lia-quick-add-error">Sorry, something went wrong loading this product.</div>';
  }

  function pickSizeOptionIndex(product) {
    if (!product.options || product.options.length === 0) return 0;
    for (var i = 0; i < product.options.length; i++) {
      if (String(product.options[i]).toLowerCase().indexOf('size') !== -1) {
        return i;
      }
    }
    return 0;
  }

  function renderProduct(product, productUrl) {
    var body = modal.querySelector('.lia-quick-add-body');
    var optionIndex = pickSizeOptionIndex(product);
    var optionKey = 'option' + (optionIndex + 1);
    var image = product.featured_image || (product.images && product.images[0]) || '';

    var needsSizeSelect = product.variants.length > 1;

    var html = '';
    html += '<div class="lia-quick-add-header">';
    if (image) {
      html += '<img class="lia-quick-add-image" src="' + image + '" alt="' + escapeHtml(product.title) + '">';
    }
    html += '<div class="lia-quick-add-title-price">';
    html += '<div class="lia-quick-add-title">' + escapeHtml(product.title) + '</div>';
    html += '<div class="lia-quick-add-price">' + formatMoney(product.price) + '</div>';
    html += '</div>';
    html += '</div>';

    if (needsSizeSelect) {
      html += '<div class="lia-quick-add-sizes">';
      product.variants.forEach(function (variant) {
        var label = variant[optionKey] || variant.title;
        html +=
          '<button type="button" class="lia-size-btn' + (variant.available ? '' : ' is-oos') + '" ' +
          'data-variant-id="' + variant.id + '" ' +
          (variant.available ? '' : 'disabled ') +
          '>' + escapeHtml(label) + '</button>';
      });
      html += '</div>';
    } else if (product.variants.length === 1) {
      selectedVariantId = product.variants[0].available ? product.variants[0].id : null;
    }

    html += '<div class="lia-quick-add-actions">';
    html += '<button type="button" class="lia-quick-add-submit lia-qa-btn-primary"' + (needsSizeSelect ? ' disabled' : '') + '>' +
      (product.variants.length && !product.variants.some(function (v) { return v.available; }) ? 'Sold Out' : 'Quick Add to Basket') +
      '</button>';
    html += '<button type="button" class="lia-quick-add-continue lia-qa-btn-secondary">Continue Shopping</button>';
    html += '</div>';
    html += '<a href="' + productUrl + '" class="lia-quick-add-view-link">View full product page</a>';
    html += '<div class="lia-quick-add-status"></div>';

    body.innerHTML = html;

    var submitBtn = body.querySelector('.lia-quick-add-submit');
    var soldOut = product.variants.length > 0 && !product.variants.some(function (v) { return v.available; });
    if (soldOut) {
      submitBtn.disabled = true;
    }

    var continueBtn = body.querySelector('.lia-quick-add-continue');
    if (continueBtn) {
      continueBtn.addEventListener('click', closeModal);
    }

    body.querySelectorAll('.lia-size-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        body.querySelectorAll('.lia-size-btn').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        selectedVariantId = btn.getAttribute('data-variant-id');
        submitBtn.disabled = false;
      });
    });

    submitBtn.addEventListener('click', function () {
      if (!selectedVariantId) return;
      addToCart(selectedVariantId, submitBtn, body);
    });
  }

  function addToCart(variantId, submitBtn, body) {
    submitBtn.disabled = true;
    submitBtn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:change', { detail: cart }));
        var actionsRow = body.querySelector('.lia-quick-add-actions');
        if (actionsRow) {
          actionsRow.style.display = 'none';
        }
        body.querySelector('.lia-quick-add-status').innerHTML =
          '<div class="lia-quick-add-added">Added to your bag.</div>' +
          '<div class="lia-quick-add-actions">' +
          '<a href="/cart" class="lia-quick-add-view-bag lia-qa-btn-primary" data-skip-transition>View Bag</a>' +
          '<button type="button" class="lia-quick-add-continue-2 lia-qa-btn-secondary">Continue Shopping</button>' +
          '</div>';
        var continueBtn2 = body.querySelector('.lia-quick-add-continue-2');
        if (continueBtn2) {
          continueBtn2.addEventListener('click', closeModal);
        }
      })
      .catch(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Quick Add to Basket';
        body.querySelector('.lia-quick-add-status').innerHTML =
          '<div class="lia-quick-add-error">Could not add to bag. Please try again.</div>';
      });
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(String(str == null ? '' : str)));
    return div.innerHTML;
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    var amount = (cents / 100).toFixed(2);
    return '£' + amount;
  }

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest('.lia-quick-add-btn');
      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();

      var handle = trigger.getAttribute('data-handle');
      var url = trigger.getAttribute('data-url');
      if (!handle) return;

      currentHandle = handle;
      selectedVariantId = null;

      openModal();
      renderLoading();

      fetch('/products/' + handle + '.js')
        .then(function (res) {
          if (!res.ok) throw new Error('not found');
          return res.json();
        })
        .then(function (product) {
          if (currentHandle !== handle) return;
          renderProduct(product, url);
        })
        .catch(function () {
          if (currentHandle !== handle) return;
          renderError();
        });
    },
    true
  );
})();